import ajax from '../utils/ajax'

export default {
    listRecentVessels: () => ajax.post('/api/callLogs/recentVessels')
};
